export function AdvancedLink(props: {
  href: string;
  noFollow?: boolean;
  openInNewTab?: boolean;
  children?: React.ReactNode;
}) {
  const rel = props.noFollow
    ? 'nofollow'
    : props.openInNewTab
      ? 'noopener noreferrer'
      : undefined;

  return (
    <a
      href={props.href}
      rel={rel}
      target={props.openInNewTab ? '_blank' : undefined}
    >
      {props.children}
    </a>
  );
}
